export const createProductDetailsSlice = (set) => ({
  selectedProductTypeId: null,
  couponApplicationId: 0,
  applicationId: null,
  isCreditScoreChecked: true,
  discountAmount: 0,
  couponAvailable: true,
  setSelectedProductTypeId: (id) => set({ selectedProductTypeId: id }),
  setCouponApplicationId: (id) => set({ couponApplicationId: id }),
  setApplicationId: (id) => set({ applicationId: id }),
  setIsCreditScoreChecked: (checked) => set({ isCreditScoreChecked: checked }),
  setDiscountAmount: (amount) => set({ discountAmount: amount }),
  setCouponAvailable: (available) => set({ couponAvailable: available }),
  clearProductDetails: () =>
    set({
      selectedProductTypeId: null,
      selectedCouponId: null,
      isCreditScoreChecked: true,
      couponAvailable: true,
    }),
});
